export const USER_ADMIN_IDS = [2, 6];
